'use client';

import { c as _c } from "react/compiler-runtime";
import { keycloakCompleteResetCredential } from '@/app/lib/rest';
import { Step, Steps } from '@/components/selfservices/Steps';
import { TSRException } from '@/helpers/rest';
import { useRouter } from '@/i18n/routing';
import { useFeatureFlags } from '@/providers/feature-flags-provider';
import { Realm, ResetCredential } from '@diamond-block/api/v1/self-service/schema/keycloak';
import { IconSize } from '@diamond-block/ui';
import { zodResolver } from '@hookform/resolvers/zod';
import { signOut } from 'next-auth/react';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';
import { FormProvider, useForm, useWatch } from 'react-hook-form';
import toast from 'react-hot-toast';
import { TbDeviceMobile, TbFingerprint } from 'react-icons/tb';
import z from 'zod/v3';
import { RadioCard } from '../RadioCard';
import { ErrorDisplay } from '../feedback/ErrorDisplay';
export const ResetCredentialForm = t0 => {
  const $ = _c(107);
  const {
    steps,
    confirmToken,
    realm: t1
  } = t0;
  const realm = t1 === undefined ? "Primary" : t1;
  const t = useTranslations("ResetCredentialForm");
  const flags = useFeatureFlags();
  const {
    push
  } = useRouter();
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = zodResolver(ResetCredential);
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== realm) {
    t3 = {
      resolver: t2,
      defaultValues: {
        realm,
        credential: "OTP" as const
      }
    };
    $[1] = realm;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const form = useForm(t3);
  const {
    handleSubmit,
    formState: t4,
    setValue,
    control
  } = form;
  const {
    isSubmitting
  } = t4;
  let t5;
  if ($[3] !== control) {
    t5 = {
      control,
      name: "realm"
    };
    $[3] = control;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const currentRealm = useWatch(t5);
  let t6;
  if ($[5] !== currentRealm || $[6] !== setValue) {
    t6 = () => {
      if (currentRealm === "Aurora") {
        setValue("credential", "OTP");
      }
    };
    $[5] = currentRealm;
    $[6] = setValue;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== currentRealm) {
    t7 = [currentRealm];
    $[8] = currentRealm;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  useEffect(t6, t7);
  let t8;
  if ($[10] !== steps) {
    t8 = <div className="flex justify-center"><Steps steps={steps} currentStep={3} /></div>;
    $[10] = steps;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== confirmToken || $[13] !== flags || $[14] !== push || $[15] !== t) {
    t9 = data => toast.promise(keycloakCompleteResetCredential({
      body: data
    }, confirmToken).then(_temp), {
      loading: t("resetting-credential"),
      success: () => {
        if (data.realm === "Primary") {
          signOut({
            redirect: false
          }).finally(() => push(`${flags.loginRedirectUrl}/Workbench`));
        } else {
          push(`${flags.loginRedirectUrl}/aurora`);
        }
        return t("successfully-reset");
      },
      error: _temp2
    });
    $[12] = confirmToken;
    $[13] = flags;
    $[14] = push;
    $[15] = t;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== handleSubmit || $[18] !== t9) {
    t10 = handleSubmit(t9);
    $[17] = handleSubmit;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t) {
    t11 = t("target-realm");
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11) {
    t12 = <legend className="fieldset-legend">{t11}</legend>;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t) {
    t13 = t("target-realm-description");
    $[24] = t;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t13) {
    t14 = <p className="fieldset-label">{t13}</p>;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t) {
    t15 = t("primary-realm");
    $[28] = t;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t) {
    t16 = t("primary-realm-description");
    $[30] = t;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t15 || $[33] !== t16) {
    t17 = <RadioCard title={t15} name="realm" value="Primary">{t16}</RadioCard>;
    $[32] = t15;
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t) {
    t18 = t("aurora-realm");
    $[35] = t;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t) {
    t19 = t("realm-selection-unavailable");
    $[37] = t;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t) {
    t20 = t("aurora-realm-description");
    $[39] = t;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== t18 || $[42] !== t19 || $[43] !== t20) {
    t21 = <RadioCard title={t18} name="realm" value="Aurora" hoverTitle={t19}>{t20}</RadioCard>;
    $[41] = t18;
    $[42] = t19;
    $[43] = t20;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== t17 || $[46] !== t21) {
    t22 = <div className="my-2 grid gap-8 md:grid-cols-2">{t17}{t21}</div>;
    $[45] = t17;
    $[46] = t21;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  let t23;
  if ($[48] !== t12 || $[49] !== t14 || $[50] !== t22) {
    t23 = <fieldset className="fieldset my-1">{t12}{t14}{t22}</fieldset>;
    $[48] = t12;
    $[49] = t14;
    $[50] = t22;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  let t24;
  if ($[52] !== t) {
    t24 = t("credential-type");
    $[52] = t;
    $[53] = t24;
  } else {
    t24 = $[53];
  }
  let t25;
  if ($[54] !== t24) {
    t25 = <legend className="fieldset-legend">{t24}</legend>;
    $[54] = t24;
    $[55] = t25;
  } else {
    t25 = $[55];
  }
  let t26;
  if ($[56] !== t) {
    t26 = t("credential-type-description");
    $[56] = t;
    $[57] = t26;
  } else {
    t26 = $[57];
  }
  let t27;
  if ($[58] !== t26) {
    t27 = <p className="fieldset-label">{t26}</p>;
    $[58] = t26;
    $[59] = t27;
  } else {
    t27 = $[59];
  }
  let t28;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <TbDeviceMobile size={IconSize.cardTitle} />;
    $[60] = t28;
  } else {
    t28 = $[60];
  }
  let t29;
  if ($[61] !== t) {
    t29 = t("totp");
    $[61] = t;
    $[62] = t29;
  } else {
    t29 = $[62];
  }
  let t30;
  if ($[63] !== t29) {
    t30 = <>{t28} {t29}</>;
    $[63] = t29;
    $[64] = t30;
  } else {
    t30 = $[64];
  }
  let t31;
  if ($[65] !== t) {
    t31 = t("totp-description");
    $[65] = t;
    $[66] = t31;
  } else {
    t31 = $[66];
  }
  let t32;
  if ($[67] !== t30 || $[68] !== t31) {
    t32 = <RadioCard title={t30} name="credential" value="OTP">{t31}</RadioCard>;
    $[67] = t30;
    $[68] = t31;
    $[69] = t32;
  } else {
    t32 = $[69];
  }
  let t33;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <TbFingerprint size={IconSize.cardTitle} />;
    $[70] = t33;
  } else {
    t33 = $[70];
  }
  let t34;
  if ($[71] !== t) {
    t34 = t("webauthn");
    $[71] = t;
    $[72] = t34;
  } else {
    t34 = $[72];
  }
  let t35;
  if ($[73] !== t34) {
    t35 = <>{t33} {t34}</>;
    $[73] = t34;
    $[74] = t35;
  } else {
    t35 = $[74];
  }
  const t36 = currentRealm === "Aurora";
  let t37;
  if ($[75] !== t) {
    t37 = t("webauthn-description");
    $[75] = t;
    $[76] = t37;
  } else {
    t37 = $[76];
  }
  let t38;
  if ($[77] !== t35 || $[78] !== t36 || $[79] !== t37) {
    t38 = <RadioCard title={t35} name="credential" value="WebAuthn" disabled={t36}>{t37}</RadioCard>;
    $[77] = t35;
    $[78] = t36;
    $[79] = t37;
    $[80] = t38;
  } else {
    t38 = $[80];
  }
  let t39;
  if ($[81] !== t32 || $[82] !== t38) {
    t39 = <div className="my-2 grid gap-8 md:grid-cols-2">{t32}{t38}</div>;
    $[81] = t32;
    $[82] = t38;
    $[83] = t39;
  } else {
    t39 = $[83];
  }
  let t40;
  if ($[84] !== t25 || $[85] !== t27 || $[86] !== t39) {
    t40 = <fieldset className="fieldset my-1">{t25}{t27}{t39}</fieldset>;
    $[84] = t25;
    $[85] = t27;
    $[86] = t39;
    $[87] = t40;
  } else {
    t40 = $[87];
  }
  let t41;
  if ($[88] !== isSubmitting) {
    t41 = isSubmitting && <span className="loading loading-spinner" />;
    $[88] = isSubmitting;
    $[89] = t41;
  } else {
    t41 = $[89];
  }
  let t42;
  if ($[90] !== t) {
    t42 = t("request");
    $[90] = t;
    $[91] = t42;
  } else {
    t42 = $[91];
  }
  let t43;
  if ($[92] !== isSubmitting || $[93] !== t41 || $[94] !== t42) {
    t43 = <div className="mt-5 flex flex-row justify-end p-2"><button className="btn btn-primary" disabled={isSubmitting} type="submit">{t41}{t42}</button></div>;
    $[92] = isSubmitting;
    $[93] = t41;
    $[94] = t42;
    $[95] = t43;
  } else {
    t43 = $[95];
  }
  let t44;
  if ($[96] !== t10 || $[97] !== t23 || $[98] !== t40 || $[99] !== t43) {
    t44 = <form onSubmit={t10}>{t23}{t40}{t43}</form>;
    $[96] = t10;
    $[97] = t23;
    $[98] = t40;
    $[99] = t43;
    $[100] = t44;
  } else {
    t44 = $[100];
  }
  let t45;
  if ($[101] !== form || $[102] !== t44) {
    t45 = <FormProvider {...form}>{t44}</FormProvider>;
    $[101] = form;
    $[102] = t44;
    $[103] = t45;
  } else {
    t45 = $[103];
  }
  let t46;
  if ($[104] !== t45 || $[105] !== t8) {
    t46 = <>{t8}{t45}</>;
    $[104] = t45;
    $[105] = t8;
    $[106] = t46;
  } else {
    t46 = $[106];
  }
  return t46;
};
function _temp(res) {
  if (res.status !== 204) {
    throw new TSRException(res);
  }
  return res;
}
function _temp2(err) {
  return <ErrorDisplay err={err} />;
}